'use client';
const tasks = new Map();
/** Используется для предотвращения повторного запуска выполнения Promise. */ const atomicTask = (key, factory)=>{
    if (tasks.has(key)) {
        return tasks.get(key);
    }
    const promise = factory().then((result)=>{
        tasks.delete(key);
        return result;
    }).catch((error)=>{
        tasks.delete(key);
        throw error;
    });
    tasks.set(key, promise);
    return promise;
};

export { atomicTask };
//# sourceMappingURL=atomicTask.js.map
